import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../style/AppPages.css";
import "../../style/Login.css";
import "../../style/FormStyles.css";
import { loginAccount } from "../../controllers/AccountConnectionLayer";
import { useAuth } from '../../contexts/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth(); // Get user state
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation();

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await loginAccount(formData, navigate);

            // Wait until user is set in context before redirecting
            const checkUser = async () => {
                if (user) {
                    navigate("/"); // Redirect only when user is available
                } else {
                    setTimeout(checkUser, 500); // Retry in 500ms
                }
            };

            checkUser();
        } catch (error) {
            alert("Failed to log in. " + error.message);
        }
    };

    return (
        <div class="page-padding">
            <div className="login-container">
                <h1 className="title-login">{t("account.accountTitle")}</h1>
                <div className="login-sections">
                    <div className="login-section">
                        <h2>{t("account.LoginTitle")}</h2>
                        <p>{t("account.LoginText")}</p>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>{t("account.emailLabel")}</label>
                                <input
                                        type="email"
                                        name="email"
                                        placeholder={t("account.emailLabel")}
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                            </div>
                            <div className="form-group">
                                <label>{t("account.passwordLabel")}</label>
                                <div className="password-field">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder={t("account.passwordLabel")}
                                        value={formData.password}
                                        onChange={handleInputChange}
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEyeSlash : faEye}
                                        className="eye-icon"
                                        onClick={togglePasswordVisibility}
                                    />
                                </div>
                            </div>
                            <button type="submit">{t("account.LoginTitle")}</button>
                        </form>
                        <p>
                            <a href="/forgot-password">{t("account.forgotPassword")}</a>
                        </p>
                    </div>
                    <div className="login-section">
                        <h2>{t("account.newCustomer")}</h2>
                        <p>
                        {t("account.createAccountText")}
                        </p>
                        <button onClick={() => navigate("/account/register")}>{t("account.createAccountButton")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
